import { apiClient } from "../client";
export const dilapidationService = {
    /** Get dilapidation report by job ID. Returns 404 if not found. */
    getByJobId: (jobId) => apiClient.get(`/jobs/${jobId}/dilapidation`),
    /** Create dilapidation report for job (no body). */
    create: (jobId) => apiClient.post(`/jobs/${jobId}/dilapidation`),
    /** Update dilapidation (sections, status). */
    update: (jobId, data) => apiClient.put(`/jobs/${jobId}/dilapidation`, data),
    /** Update dilapidation status only. */
    updateStatus: (jobId, status) => apiClient.put(`/jobs/${jobId}/dilapidation/status`, {
        status,
    }),
    /** Update dilapidation feedback (client approve/comment). */
    updateFeedback: (jobId, data) => apiClient.put(`/jobs/${jobId}/dilapidation/feedback`, data),
    /** Upload document to a section (multipart: file, optional type). */
    uploadSectionDocument: (sectionId, file, type) => {
        const formData = new FormData();
        formData.append("file", file);
        if (type)
            formData.append("type", type);
        return apiClient.post(`/dilapidation/sections/${sectionId}/documents`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    },
    /** Delete a section document. */
    deleteDocument: (documentId) => apiClient.delete(`/dilapidation/documents/${documentId}`),
    /** Delete dilapidation report and cascade sections/documents. */
    delete: (jobId) => apiClient.delete(`/jobs/${jobId}/dilapidation`),
};
